<template>
  <div>
    <b-modal 
      :id="modalID" 
      :header-class="`align-items-center px-20 py-15`"
      body-class="px-20 py-30"
      :hide-header="true"
      :hide-footer="true"
      no-close-on-backdrop
      no-close-on-esc
      @show="init()"
      @hidden="clear()"
    >
      <!-- <template #modal-header>
        <div class="modal-title">
          <span class="fs-db-28">{{ 'welcome' }}</span>
        </div>
      </template> -->
      <div class="modal-body-wrapper">
        <div
          :id="`close-${modalID}`"
          type="button"
          class="close-modal"
          aria-label="Close"
          @click.prevent="onClose()"
        >
          <i class="fal fa-times"></i>
        </div>
        <div class="bg-half">
        </div>
        <div class="d-flex content-wrapper" style="flex-direction: column;">
          <div class="header-title">{{$t('engine.modal.welcome.lblTitle',languageEngine)}}</div>
          <div>
            <img :src="require(`@/assets/images/logo/logo-mwe-full.png`)" />
          </div>
          <div class="space-between img-wrapper">
            <img :src="require(`@/assets/images/modal_welcome.png`)" />
          </div>
          <div class="sub-header" v-html="$t('engine.modal.welcome.lblSubHeader',languageEngine)" />
          <div class="detail">
            {{$t('engine.modal.welcome.lblDetail',languageEngine)}}
          </div>
          <div class="pt-20">
            <a class="btn px-gd-2 fs-db-20 fw-400 btn-blue btn-md" @click.prevent="onClose()" href="javascript:void(0);" style="border-radius: 21px;" >
              {{$t('engine.modal.welcome.btnSubmit',languageEngine)}}  <i class="fa fal fa-chevron-right fa-w-14 ml-5"></i>
            </a>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
  },
  data() {
    return {
      modalID: 'modal-welcome'
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      modal: "design/modal",
    }),
  },
  methods: {
    init() {
      console.log('init')
    },
    clear() {
      console.log('clear')
    },
    onClose() {
      localStorage.setItem('firstTime', '0')
      this.$bvModal.hide(this.modalID);
      this.$store.dispatch("design/snapshot/clearDiff");
      this.$store.dispatch("design/setModal", { name: "" });
    },
  },
  mounted () {
    if (localStorage.getItem('firstTime') == '1') {
      this.$store.dispatch("design/setModal", {
        name: "modal-welcome",
        payload: {},
      });
      this.$bvModal.show('modal-welcome');
    }
  },
  watch: {
    modal: {
      handler() {
        if (this.modal == this.modalID) {
          this.$bvModal.show(this.modalID);
        }
      },
    },
  },
};
</script>

<style lang="scss">
#modal-welcome {
  .modal-content {
    border-radius: 10px;
    border: none;
  }
  .modal-body-wrapper {
    .close-modal {
      position: absolute;
      top: 0;
      right: -50px;
      background-color: rgba(255,255,255,0.1);
      mix-blend-mode: normal;
      border-radius: 4px;
      width: 40px;
      height: 40px;
      font-size: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        color: #FFF
      }
    }
    .bg-half {
      top: 0;
      left: 0;
      z-index: 1;
      background: linear-gradient(138.6deg, #91E9FF -63.08%, #2198D8 2.48%, #27AFE3 52.77%, #27DBE3 120.97%);
      height: 50%;
      width: 100%;
      position: absolute;
      border-top-right-radius: 8px;
      border-top-left-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .content-wrapper {
      flex-direction: column;
      z-index: 2;
      position: relative;
      align-items: center;
  
      .header-title {
        font-family: 'MWE_DB_Heavent';
        font-style: normal;
        font-weight: 300;
        font-size: 36px;
        line-height: 50px;
        color: #FFFFFF;
      }
      .detail {
        font-family: 'MWE_DB_Heavent';
        font-size: 30px;
        font-weight: 300;
        line-height: 34px;
      }
      .img-wrapper {
        padding-top: 15px;
        width: 100%;
        height: 306px;
        text-align: center;
      }
      .sub-header {
        font-family: 'MWE_DB_Heavent';
        font-size: 32px;
        font-weight: 500;
        line-height: 34px;
        text-align: center;
      }
    }
  }
}
</style>